import {Injectable} from '@angular/core';
import {SessionStore} from 'phd-akita-session';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {map, tap} from 'rxjs/operators';
import {Observable, of} from 'rxjs';

export const getEnv = (): { prod: boolean, uat: boolean, dev: boolean, } => {
  if (environment.production) {
    return {prod: true, dev: false, uat: false};
  } else if (window.location.hostname === 'localhost') {
    return {prod: false, dev: true, uat: false};
  }
  return {prod: false, dev: false, uat: true};
};

export class User {
  token: string;
  id: string;
  name: string;
  roles: string;
  branch: string;
}

const APPLICATION_FORM_URLENCODED = {
  headers: new HttpHeaders({
    'Content-Type': 'application/x-www-form-urlencoded'
  })
};


const parseJwt = (token: string): any => {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(atob(base64).split('').map((c) => {
    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
  }).join(''));

  return JSON.parse(jsonPayload);
};

const jwtUserInfoToUser = (jwtUser: any): User => {
  return {
    id: jwtUser.id,
    token: jwtUser.token,
    name: jwtUser.userName,
    branch: jwtUser.branch,
    roles: jwtUser.role,
  };
};

@Injectable({
  providedIn: 'root'
})
export class SessionService {

  private restUrl: string;

  constructor(private sessionStore: SessionStore,
              private http: HttpClient) {
    this.restUrl = `${environment.baseUrl}/public`;
  }

  activeUser(): User {
    return this.sessionStore._value().user as User;
  }

  authWithToken(token: string): Observable<any> {
    return of(token).pipe(
      map(t => parseJwt(t)),
      map(u => ({
        id: u.JWT_USER_ID,
        token,
        name: u.JWT_USER_NAME,
        branch: u.JWT_USER_BRANCH,
        roles: u.JWT_USER_ROLE,
      })),
      tap((u: any) => this.setUser(u)),
    );
  }

  auth(userId: string, password: string): Observable<any> {
    return this.http.post<User>(this.restUrl + '/login', {
      userId,
      password,
      hash: `pcid-hash-*`
    }).pipe(tap(u => this.setUser(u)));
  }

  signOut(): void {
    this.sessionStore.update({user: null});
  }

  private setUser(user: User) {
    this.sessionStore.update({user});
  }

}
